import { makeAuthPlugin } from './feathers.client'

export default makeAuthPlugin({ 
    userService: 'merchants',
    entityIdField: 'id',
    responseEntityField: 'merchant',
    // accessToken: undefined, // The JWT
    // payload: undefined, // The JWT payload
    // isAuthenticatePending: false,
    // isLogoutPending: false,
    // errorOnAuthenticate: undefined,
    // errorOnLogout: undefined
})

